// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3KRos","content":"LoadingAlert_content__UQKPM"};